<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="Invoices"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title">
        <app-i18n code="Invoice Lookup"></app-i18n>
      </h1>

      <!-- <app-settings-toolbar></app-settings-toolbar> -->

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>
      <!-- <el-container class="test-line-row"> -->
        <el-row class="" :gutter="20">
            <el-col class="test-line-col" :lg="12" :md="12" :sm="24">
                <el-row class="test-line-row" >
                  <el-col style="padding: 0 5px;" :lg="24">
                    <el-row >
                      <el-col :lg="24">
                          <el-col :lg="24" style="text-align: center; border-bottom:1px solid grey"> Invoice Lookup </el-col>
                            <el-row :gutter="20">
                              <el-col :lg="24" style="justify-content: center;"> <label for="invoiceNumber">Invoice Number</label> <el-input id="invoiceNumber" :disabled="false" v-model="invoiceNumber"/> </el-col>
                            </el-row>
                            <el-row :gutter="20">
                              <el-col :lg="12" style="justify-content: center;">
                                  <label for="status">Status</label>
                                  <el-select id="status" v-model="value" clearable placeholder='choose a status' class="el-input el-input--suffix">
                                      <el-option value="PENDING">PENDING</el-option>
                                      <el-option value="APPROVED">APPROVED</el-option>
                                      <el-option value="DENIED">DENIED</el-option>
                                  </el-select>
                              </el-col>
                              <el-col :lg="12" style="justify-content: center;">
                                  <label for="refKEy">Reference Key</label> <el-input id="refKey" :disabled="false" v-model="refKey"/>
                              </el-col>
                            </el-row>
                          </el-col>
                    </el-row>
                  </el-col>
                          <el-col style="padding: 0 5px;" :lg="24">
                          <el-row>
                            <el-col :lg="24" style="text-align: center; border-bottom:1px solid grey"> Submission Lookup </el-col>
                            <el-col :lg="24" :md="24" :sm="24">
                              <el-row :gutter="20">
                                <el-col :lg="12" :md="24" :sm="24" style="justify-content: center;"> <label for="startDate">Submission Start Date</label> <el-date-picker id="startDate"  :disabled="false" v-model="startDate"/> </el-col>
                                <el-col :lg="12" :md="24" :sm="24" style="justify-content: center;"> <label for="endDate">Submission End Date</label> <el-date-picker id="endDate"  :disabled="false" v-model="endDate"/> </el-col>
                              </el-row>
                            </el-col>
                            <el-col :lg="24" :md="24" :sm="24">
                              <el-row :gutter="20">
                                <el-col :lg="24" style="justify-content: center;"> <label for="userEmail">User Email</label> <el-input id="userEmail" :disabled="false" v-model="userEmail"/> </el-col>
                              </el-row>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :lg="24" style="justify-content: center;">
                                  <label for="status">Submission Type</label>
                                  <el-select id="type" v-model="type" clearable placeholder='choose a submission type' class="el-input el-input--suffix">
                                      <el-option value="Integrator">Integrator</el-option>
                                      <el-option value="Farmer">Farmer</el-option>
                                  </el-select>
                              </el-col>
                          </el-row>  
                           
                            
                            <el-row :gutter="20">
                              <el-col :lg="24" style="justify-content: center; align-items: center; display: flex;"><el-button type="primary" @click="submitSearchParams">Search <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div> </el-button></el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    
            <el-col :lg="12" :md="12" :sm="24" >
              <el-row class="test-line-row" style="height: 32em; overflow: scroll;">
                  <el-col :lg="24" :md="24" :sm="24">
                    <el-row >
                      <el-col :lg="24">
                        <el-row>
                          <el-col :lg="24" style="text-align: center; border-bottom:1px solid grey"> Invoices </el-col>
                          <el-col style="padding: 0 5px;" :lg="24" id="invoice-search-row"> 
                            
                            
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
            </el-col>
          </el-row>
      <!-- </el-container> -->
    </div>
  </div>
</template>

<script>
import { InvoicesModel } from '@/modules/invoices/invoices-model';
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@/shared/form/form-schema';
import InvoicesToolbar from '@/modules/invoices/components/invoices-toolbar.vue';
import firebase from 'firebase';

const { fields } = InvoicesModel;
const formSchema = new FormSchema([fields.theme]);

export default {
  name: 'invoices-lookup',

  components: {
    [InvoicesToolbar.name]: InvoicesToolbar,
  },

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      invoiceNumber: null,
      startDate: null,
      endDate: null,
      userEmail: null,
      searchArr: [],
      value: null,
      refKey: null,
      type: null
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      settings: 'settings/settings',
      findLoading: 'settings/findLoading',
      saveLoading: 'settings/saveLoading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind();
    this.model = formSchema.initialValues(this.settings);
  },
  beforeMount(){
    this.invoiceData = [];
  },
  mounted() {
    // this.getInvoiceData();
    // console.log(this.userData)
    // this.getInvoices();
    // this.getImageUrl();
    var searchArr = ["", "", "", "", "PENDING", "", ""]
    this. searchInvoices(searchArr);
  },

  methods: {
    ...mapActions({
      doFind: 'settings/doFind',
      doSave: 'settings/doSave',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.settings);
    },
    submitSearchParams(){
        this.searchArr = [];
        let invoiceNumber = document.getElementById('invoiceNumber').value
        let startDate = document.getElementById('startDate').value
        let endDate = document.getElementById('endDate').value
        let userEmail = document.getElementById('userEmail').value
        let status = document.getElementById('status').value
        
        let refKey = document.getElementById('refKey').value
        let type = document.getElementById('type').value
        console.log('status: ' + status)

        // if(invoiceNumber){
        //     this.searchArr.push(invoiceNumber);
        // }
        // if(startDate && endDate){
        //     this.searchArr.push(startDate);
        //     this.searchArr.push(endDate);
        // }
        // if(userEmail) {
        //     this.searchArr.push(userEmail);
        // }
        var searchArr = [invoiceNumber, startDate, endDate, userEmail, status, refKey, type]

        this.searchInvoices(searchArr)
    },
    async popOnLoad() {
        await firebase
            .firestore()
            .collection("invoices")
            .where('status', "==", "PENDING")
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                console.log('No matching documents.');
                return;
                }  

                snapshot.forEach(doc => {
                    console.log(doc.id, '=>', doc.data());

                    var refId = doc.data().refKey || doc.id;

                    //create data
                    let data = doc.data();
                    //create containing col
                  var elCol = document.createElement("el-col");

                  //random Id for the container
                  var genID = this.guidGenerator();
                  elCol.id = "invoiceData_"+genID
                  elCol.style.borderBottom = "1px solid grey"
                  //make container responsive
                  elCol.classList.add("el-col", "el-col-24", "el-col-lg-24");
                  
                    //for every invoic    
                    for(var invoice in data){
                      console.log(data[invoice]);
                      
                      if(type == "invoice"){  
                        if(invoice == "distributor"){
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        } else if(invoice == "refKey") {
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        } else {
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        }
                      } else {
                          if(invoice == "email"){
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                          } else if(invoice == "entryDate"){
                              let time = this.convert(data[invoice]);
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ time +"</span></el-col></el-col></el-row>";
                          } else {
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                          }
                          
                      }
                    //  else if(invoice == 'entryDate'){
                    //     //do nothing, do not show
                    //   } else {
                    //     var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center; border-bottom: 1px solid grey;'><span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span><span style='float: center;'>"+ data[invoice] +"</span></el-col></el-row>";
                    //   }
                      
                      elCol.innerHTML += elData;
                      
                    }
                    elCol.style.cursor = "pointer";
                    
                      elCol.onclick = function(){
                        this.$router.replace({ name: 'invoice', query: { refKey: refId } })
                      }
                    document.getElementById('invoice-search-row').appendChild(elCol);
                });
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
    },   
    async searchInvoices(searchArr) {
         document.getElementById('invoice-search-row').innerHTML = "";
        const vm = this;
        let query;
        
        let type;
        console.log(searchArr)

        // return;

        if(searchArr[0] != ""){
            let queryRef = await firebase
                .firestore()
                .collection("invoices")
            console.log("firing 1")
            query = queryRef.where('invoiceNumber', "==", searchArr[0])
            type = "invoice";
            
        } else if(searchArr[4] != "") {
            let queryRef = await firebase
                .firestore()
                .collection("invoices")
            console.log("firing status")
            query = queryRef.where('status', "==", searchArr[4])
            type = "invoice";
        } else if(searchArr[5] != ""){
          console.log(searchArr[5])
            let queryRef = await firebase
                .firestore()
                .collection("invoices")
                query = queryRef.where('refKey', "==", searchArr[5])
            
        } else {
            type = "submission"
            let queryRef = await firebase
                .firestore()
                .collection("submissions")
            if(searchArr[1] != ""){
                console.log("firing 2")
                var startDate = new Date(searchArr[1]).getTime() / 1000
                console.log(startDate)
                query = queryRef.where('entryDate', ">=", startDate)
            }
            if(searchArr[2] != ""){
                console.log("firing 3")
                var endDate = new Date(searchArr[2]).getTime() / 1000
                console.log(endDate)
                query = queryRef.where('entryDate', "<=", endDate)
            }
            if(searchArr[3] != ""){
                console.log("firing 4")
                query = queryRef.where('email', "==", searchArr[3])
            }
            if(searchArr[6] != "") {
            
            query = queryRef.where('type', "==", searchArr[6])
            }
            
            
        }
        query.get()
          .then(snapshot => {
                if (snapshot.empty) {
                console.log('No matching documents.');
                return;
                }  

                snapshot.forEach(doc => {
                    console.log(doc.id, '=>', doc.data());

                    var refId = doc.data().refKey || doc.id;

                    //create data
                    let data = doc.data();
                    //create containing col
                  var elCol = document.createElement("el-col");

                  //random Id for the container
                  var genID = vm.guidGenerator();
                  elCol.id = "invoiceData_"+genID
                  elCol.style.borderBottom = "1px solid grey"
                  //make container responsive
                  elCol.classList.add("el-col", "el-col-24", "el-col-lg-24");
                  
                    //for every invoic    
                    for(var invoice in data){
                      console.log(data[invoice]);
                      
                      if(type == "invoice"){  
                        if(invoice == "distributor"){
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        } else if(invoice == "refKey") {
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        } else {
                            var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                        }
                      } else {
                          if(invoice == "email"){
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                          } else if(invoice == "entryDate"){
                              let time = vm.convert(data[invoice]);
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ time +"</span></el-col></el-col></el-row>";
                          } else {
                              var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center;'><el-col class='el-col el-col-12 el-col-lg-12'> <span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span></el-col> <el-col class='el-col el-col-12 el-col-lg-12'><span style='float: left;'>"+ data[invoice] +"</span></el-col></el-col></el-row>";
                          }
                          
                      }
                    //  else if(invoice == 'entryDate'){
                    //     //do nothing, do not show
                    //   } else {
                    //     var elData = "<el-row><el-col class='el-col el-col-24 el-col-lg-24' style='text-align: center; border-bottom: 1px solid grey;'><span style='font-weight: bold; float: left; padding-left: 5px'>"+ invoice +": </span><span style='float: center;'>"+ data[invoice] +"</span></el-col></el-row>";
                    //   }
                      
                      elCol.innerHTML += elData;
                      
                    }
                    elCol.style.cursor = "pointer";
                    
                      elCol.onclick = function(){
                        vm.$router.replace({ name: 'invoice', query: { refKey: refId } })
                      }
                    document.getElementById('invoice-search-row').appendChild(elCol);
                });
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
        
    },
    guidGenerator() {
        var S4 = function() {
          return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        };
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },
    convert(time){

        // Months array
        var months_arr = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

        // Convert timestamp to milliseconds
        var date = new Date(time*1000);

        // Year
        var year = date.getFullYear();

        // Month
        var month = months_arr[date.getMonth()];

        // Day
        var day = date.getDate();

        // Hours
        var hours = date.getHours();

        // Minutes
        var minutes = "0" + date.getMinutes();

        // Seconds
        var seconds = "0" + date.getSeconds();

        // Display date time in MM-dd-yyyy h:m:s format
        var convdataTime = month+' '+day+', '+year+' '+hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        
        return convdataTime;
        
    }
    
  },
};
</script>

<style>
.settings-box {
  float: left;
  width: 20px;
  height: 20px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
}
.test-line-row {
  border: grey 1px solid;
  border-radius: 5px
}
/* .test-line-col {
  border: green 1px dotted;
} */

.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }


</style>
